import { gql } from '@apollo/client';

export * from './escrowUpdateBeneficiaryNotifications.mutation.generated';

export const ESCROW_UPDATE_BENEFICIARY_NOTIFICATIONS = gql`
  mutation escrowUpdateBeneficiaryNotifications(
    $escrowId: ID!
    $escrowParams: EscrowUpdateBeneficiaryNotificationsParams!
  ) {
    escrowUpdateBeneficiaryNotifications(input: { escrowId: $escrowId, escrowParams: $escrowParams }) {
      success
      errors
      escrow {
        id
        beneficiaryActivityNotification
        beneficiaryDisruptionNotification
        beneficiaryDisruptionNotificationGracePeriod
      }
    }
  }
`;
